import originalUrl from 'original-url';
/**
 * Get the host for server-side calls.
 */

export default (function (req) {
  if (!req) {
    throw new Error('A request object must be passed to establish the site config on the server.');
  }

  return originalUrl(req).hostname;
});